import { TOGGLE_CALENDAR_SYNC_FAILURE, TOGGLE_CALENDAR_SYNC_REQUEST, TOGGLE_CALENDAR_SYNC_SUCCESS } from 'actions/stylist/toggleCalendarSync.types';
import asArray from 'utils/arrays/asArray.util';

import {
  ADD_STYLIST_FAILURE,
  ADD_STYLIST_REQUEST,
  ADD_STYLIST_SUCCESS,
  CLEAR_REQUEST_ERROR,
  CLEAR_STYLIST_STATE,
  DELETE_CATEGORY_FOR_STYLIST_FAILURE,
  DELETE_CATEGORY_FOR_STYLIST_REQUEST,
  DELETE_CATEGORY_FOR_STYLIST_SUCCESS,
  DELETE_SERVICE_FOR_STYLIST_FAILURE,
  DELETE_SERVICE_FOR_STYLIST_REQUEST,
  DELETE_SERVICE_FOR_STYLIST_SUCCESS,
  DELETE_STYLIST_FAILURE,
  DELETE_STYLIST_REQUEST,
  DELETE_STYLIST_SUCCESS,
  DISABLE_REMOTE_LOGIN_FAILURE,
  DISABLE_REMOTE_LOGIN_REQUEST,
  DISABLE_REMOTE_LOGIN_SUCCESS,
  EDIT_CATEGORY_FOR_STYLIST_FAILURE,
  EDIT_CATEGORY_FOR_STYLIST_REQUEST,
  EDIT_CATEGORY_FOR_STYLIST_SUCCESS,
  EDIT_SERVICE_FOR_STYLIST_FAILURE,
  EDIT_SERVICE_FOR_STYLIST_REQUEST,
  EDIT_SERVICE_FOR_STYLIST_SUCCESS,
  EDIT_STYLIST_FAILURE,
  EDIT_STYLIST_REQUEST,
  EDIT_STYLIST_SUCCESS,
  ENABLE_REMOTE_LOGIN_FAILURE,
  ENABLE_REMOTE_LOGIN_REQUEST,
  ENABLE_REMOTE_LOGIN_SUCCESS,
  GET_STYLIST_FAILURE,
  GET_STYLIST_REQUEST,
  GET_STYLIST_SUCCESS,
  GET_STYLISTS_FAILURE,
  GET_STYLISTS_REQUEST,
  GET_STYLISTS_SUCCESS,
  POST_CATEGORY_FOR_STYLIST_FAILURE,
  POST_CATEGORY_FOR_STYLIST_REQUEST,
  POST_CATEGORY_FOR_STYLIST_SUCCESS,
  POST_SERVICE_FOR_STYLIST_FAILURE,
  POST_SERVICE_FOR_STYLIST_REQUEST,
  POST_SERVICE_FOR_STYLIST_SUCCESS,
  REMOVE_SAVED_STYLISTS_IDS,
  RESET_STYLIST_SAVED,
  SET_STYLIST_SAVED,
  UPDATE_ROLE_PRICE_FAILURE,
  UPDATE_ROLE_PRICE_REQUEST,
  UPDATE_ROLE_PRICE_SUCCESS,
} from 'onboarding/stylists/actions';

const INIT = Object.freeze({
  stylists: [],
  isFetching: false,
  isPosting: false,
  isSaved: false,
  errorMessage: '',
  settingsSavedStylistsIDs: [],
  settingsErrorStylistsIDs: [],
});

const stylistsReducer = (state, action) => {
  if (!state) {
    // eslint-disable-next-line no-param-reassign
    state = { ...INIT };
  }

  if (!action) {
    return state;
  }

  const { /* error, */ params, type, response, errorMessage } = action;
  if (!type) {
    return state;
  }

  if (type === ADD_STYLIST_SUCCESS) {
    const stylists = state.stylists.slice();
    if (!stylists.find((value) => value.id && response && response.id && value.id === response.id)) {
      stylists.push(response);
    }
    return { ...state, stylists, isPosting: false };
  }

  if (type === ADD_STYLIST_FAILURE) {
    return {
      ...state,
      isPosting: false,
      errorMessage,
    };
  }

  if (type === GET_STYLISTS_SUCCESS) {
    const stylists = [];
    for (let i = 0; i < response.length; i += 1) {
      if (response[i].status === 'active') {
        stylists.push(response[i]);
      }
    }
    return { ...state, stylists, isFetching: false };
  }

  if (type === GET_STYLIST_SUCCESS) {
    const stylists = state.stylists.slice();
    let updatedExisting = false;
    for (let i = 0; i < stylists.length; i += 1) {
      if (stylists[i].id === response.id) {
        stylists[i] = response;
        updatedExisting = true;
        break;
      }
    }
    if (!updatedExisting) {
      stylists.push(response);
    }
    return { ...state, stylists, isFetching: false };
  }

  if (type === EDIT_STYLIST_SUCCESS) {
    const stylists = state.stylists.slice();
    let added = false;
    for (let i = 0; i < stylists.length; i += 1) {
      if (stylists[i].id === response.id) {
        stylists[i] = response;
        added = true;
        break;
      }
    }
    if (!added) {
      stylists.push(response);
    }
    const settingsSavedStylistsIDs = state.settingsSavedStylistsIDs.slice();
    const responseId = response.id;
    const settingsErrorStylistsIDs = state.settingsErrorStylistsIDs.slice().filter((cat) => cat.id !== responseId);
    const savedCatInd = settingsSavedStylistsIDs.findIndex((cat) => cat.id === responseId);
    if (response.id && savedCatInd === -1) {
      settingsSavedStylistsIDs.push({ id: response.id, isNew: true });
    } else {
      settingsSavedStylistsIDs[savedCatInd].isNew = true;
    }
    return { ...state, settingsSavedStylistsIDs, settingsErrorStylistsIDs, stylists, isPosting: false };
  }

  if (type === EDIT_STYLIST_FAILURE) {
    const settingsErrorStylistsIDs = state.settingsErrorStylistsIDs.slice();
    const responseId = params.stylistId;
    const savedCatInd = settingsErrorStylistsIDs.findIndex((cat) => cat.id === responseId);
    if (savedCatInd === -1) {
      settingsErrorStylistsIDs.push({ id: responseId, message: errorMessage });
    } else {
      settingsErrorStylistsIDs[savedCatInd].message = errorMessage;
    }
    return { ...state, settingsErrorStylistsIDs, isPosting: false, errorMessage };
  }

  if (type === DELETE_STYLIST_SUCCESS) {
    const stylists = state.stylists.slice();
    for (let i = 0; i < stylists.length; i += 1) {
      if (stylists[i].id === params.stylistId) {
        stylists[i].status = 'deleted';
        stylists.splice(i, 1);
        break;
      }
    }
    return { ...state, stylists, isPosting: false };
  }

  if (type === REMOVE_SAVED_STYLISTS_IDS) {
    const { idsToRemove } = action;
    const settingsSavedStylistsIDs = state.settingsSavedStylistsIDs.filter(({ id }) => idsToRemove.indexOf(id) < 0);
    return { ...state, settingsSavedStylistsIDs };
  }

  if (type === CLEAR_STYLIST_STATE) {
    return { ...state, isPosting: false, isFetching: false, isSaved: false, errorMessage: '' };
  }

  if (type === TOGGLE_CALENDAR_SYNC_SUCCESS) {
    return {
      ...state,
      stylists: asArray(state.stylists).map((stylist) => (stylist.id !== response.stylist_id ? stylist : { ...stylist, has_cal_sync: response.allow_sync })),
      isFetching: false,
    };
  }

  if (type === TOGGLE_CALENDAR_SYNC_REQUEST) return { ...state, isFetching: true };
  if (type === TOGGLE_CALENDAR_SYNC_FAILURE) return { ...state, errorMessage };
  if (type === CLEAR_REQUEST_ERROR) return { ...state, errorMessage: '' };
  if (type === ADD_STYLIST_REQUEST) return { ...state, isPosting: true };
  if (type === GET_STYLISTS_REQUEST) return { ...state, isFetching: true };
  if (type === GET_STYLISTS_FAILURE) return { ...state, isFetching: false };
  if (type === GET_STYLIST_REQUEST) return { ...state, isFetching: true };
  if (type === GET_STYLIST_FAILURE) return { ...state, isFetching: false, errorMessage };
  if (type === EDIT_STYLIST_REQUEST) return { ...state, isPosting: true };
  if (type === DELETE_STYLIST_REQUEST) return { ...state, isPosting: true };
  if (type === DELETE_STYLIST_FAILURE) return { ...state, isPosting: false, errorMessage };
  if (type === POST_SERVICE_FOR_STYLIST_REQUEST) return { ...state, isPosting: true };
  if (type === POST_SERVICE_FOR_STYLIST_SUCCESS) return { ...state, isPosting: false };
  if (type === POST_SERVICE_FOR_STYLIST_FAILURE) return { ...state, isPosting: false, errorMessage };
  if (type === EDIT_SERVICE_FOR_STYLIST_REQUEST) return { ...state, isPosting: true };
  if (type === EDIT_SERVICE_FOR_STYLIST_SUCCESS) return { ...state, isPosting: false };
  if (type === EDIT_SERVICE_FOR_STYLIST_FAILURE) return { ...state, isPosting: false, errorMessage };
  if (type === DELETE_SERVICE_FOR_STYLIST_REQUEST) return { ...state, isPosting: true };
  if (type === DELETE_SERVICE_FOR_STYLIST_SUCCESS) return { ...state, isPosting: false };
  if (type === DELETE_SERVICE_FOR_STYLIST_FAILURE) return { ...state, isPosting: false, errorMessage };
  if (type === POST_CATEGORY_FOR_STYLIST_REQUEST) return { ...state, isPosting: true };
  if (type === POST_CATEGORY_FOR_STYLIST_SUCCESS) return { ...state, isPosting: false };
  if (type === POST_CATEGORY_FOR_STYLIST_FAILURE) return { ...state, isPosting: false, errorMessage };
  if (type === EDIT_CATEGORY_FOR_STYLIST_REQUEST) return { ...state, isPosting: true };
  if (type === EDIT_CATEGORY_FOR_STYLIST_SUCCESS) return { ...state, isPosting: false };
  if (type === EDIT_CATEGORY_FOR_STYLIST_FAILURE) return { ...state, isPosting: false, errorMessage };
  if (type === DELETE_CATEGORY_FOR_STYLIST_REQUEST) return { ...state, isPosting: true };
  if (type === DELETE_CATEGORY_FOR_STYLIST_SUCCESS) return { ...state, isPosting: false };
  if (type === DELETE_CATEGORY_FOR_STYLIST_FAILURE) return { ...state, isPosting: false, errorMessage };
  if (type === SET_STYLIST_SAVED) return { ...state, isSaved: true };
  if (type === RESET_STYLIST_SAVED) return { ...state, isSaved: false };
  if (type === UPDATE_ROLE_PRICE_REQUEST) return { ...state, isPosting: true };
  if (type === UPDATE_ROLE_PRICE_SUCCESS) return { ...state, isPosting: false };
  if (type === UPDATE_ROLE_PRICE_FAILURE) return { ...state, isPosting: false, errorMessage };
  if (type === ENABLE_REMOTE_LOGIN_REQUEST) return { ...state, isPosting: true };
  if (type === ENABLE_REMOTE_LOGIN_SUCCESS) return { ...state, isPosting: false };
  if (type === ENABLE_REMOTE_LOGIN_FAILURE) return { ...state, isPosting: false, errorMessage };
  if (type === DISABLE_REMOTE_LOGIN_REQUEST) return { ...state, isPosting: true };
  if (type === DISABLE_REMOTE_LOGIN_SUCCESS) return { ...state, isPosting: false };
  if (type === DISABLE_REMOTE_LOGIN_FAILURE) return { ...state, isPosting: false, errorMessage };

  return state;
};

export default stylistsReducer;
